import PriceFormatter from "features/shared/components/formatters/PriceFormatter";
import { Currency } from "features/shared/enums/currency";
import React from "react";
import PaymentUsageDTO from "../dtos/PaymentUsageDTO";
import { useTranslation } from "react-i18next";
interface IProps {
  amount: number;
  currency: Currency;
  paymentUsage: PaymentUsageDTO[];
}

const PaymentPrices: React.FC<IProps> = (props) => {
  //translations
  const tLabels = useTranslation("payments\\payments").t;

  // props
  const {amount, currency, paymentUsage} = props;

  // sub-renders
  const renderUsagePrice = () => {
    if (paymentUsage.length === 1) {
      const usagePrice = paymentUsage[0].amount;

      if (usagePrice !== amount) {
        return (
          <div className="d-none d-sm-block small text-truncate">
            {tLabels("paymentPrices.used")} <PriceFormatter amount={usagePrice!} currency={currency}/>
          </div>
        );
      }
    }
  }

  // render
  if (paymentUsage.length > 1) {
    return (
      <div className="text-truncate text-success">
        <PriceFormatter amount={amount} currency={currency}/>
      </div>
    );
  } else {
    return (
      <div>
        <div className="text-success text-truncate">
          <PriceFormatter amount={amount} currency={currency}/>
        </div>
        {renderUsagePrice()}
      </div>
    );
  }
};

export default PaymentPrices;